import { $http } from "@/plugins/api";
import { getApiClientUrl } from "@/config/runtimeConfig";
import type { Commit } from "vuex";
import { Organisation } from "../../types/organisatio";
import { Params } from "@/types/api";

interface State {
  list: Organisation[];
  total: number;
}

const state: State = {
  list: [],
  total: 0,
};

const getters = {
  dropDownList: (state: State) => state.list,
  dropDownTotal: (state: State) => state.total,
};

const actions = {
  resetState({ commit }: { commit: Commit }) {
    commit("dropDownList", []);
    commit("dropDownTotal", 0);
  },
  async getDropDownList(
    { commit }: { commit: Commit },
    {
      globalOrganisationID,
      params,
    }: {
      globalOrganisationID: string | null;
      params: Params;
    },
  ) {
    const url = new URL(`${getApiClientUrl()}/v1/idp/orgs`);

    const reqParams = new URLSearchParams();

    if (globalOrganisationID) {
      reqParams.append("parent_uuid", globalOrganisationID);
    }

    // Convert params to lowercase strings and append them to reqParams
    for (const [key, value] of Object.entries(params)) {
      reqParams.append(key, value.toString());
    }

    url.search = reqParams.toString();

    const orgsResponse = await $http.get(url.toString());

    commit("dropDownList", orgsResponse.data.data);
    commit("dropDownTotal", orgsResponse.data.total ?? 0);
  },
  async appendDropDownList(
    { commit, state }: { commit: Commit; state: State },
    {
      globalOrganisationID,
      params,
    }: {
      globalOrganisationID: string | null;
      params: Params;
    },
  ) {
    const url = new URL(`${getApiClientUrl()}/v1/idp/orgs`);
    const reqParams = new URLSearchParams();

    if (globalOrganisationID) {
      reqParams.append("parent_uuid", globalOrganisationID);
    }

    for (const [key, value] of Object.entries(params)) {
      reqParams.append(key, value.toString());
    }

    url.search = reqParams.toString();

    const orgsResponse = await $http.get(url.toString());

    commit("dropDownList", [...state.list, ...orgsResponse.data.data]);
    commit("dropDownTotal", orgsResponse.data.total ?? 0);
  },
};

const mutations = {
  dropDownList: (state: State, list: Organisation[]) => (state.list = list),
  dropDownTotal: (state: State, total: number) => (state.total = total),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
